export const load = () => ({
	title: 'Total Darkness for Restful Sleep',
	showTitle: true,
	description:
		'Struggle with unwanted light disrupting your sleep? Discover how Indow Sleep Panels create complete darkness for deeper, more restful sleep.',
});
